import { render } from "./ReturnedCreators.vue?vue&type=template&id=60c691f1&scoped=true"
import script from "./ReturnedCreators.vue?vue&type=script&lang=js"
export * from "./ReturnedCreators.vue?vue&type=script&lang=js"

import "./ReturnedCreators.vue?vue&type=style&index=0&id=60c691f1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c691f1"]])

export default __exports__